import { render, staticRenderFns } from "./InputSwitch.vue?vue&type=template&id=8b3e53c6"
import script from "./InputSwitch.vue?vue&type=script&lang=js"
export * from "./InputSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports